import React, { Component } from 'react';
import { DLModal } from 'appSrc/components/Shards';
import InnerForm from './Form';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import style from './styles/style.module.css';


class BlockModal extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            deleteConfirm: false,
            block: {},
            visible: false,
        };
    }
    componentDidUpdate( prevProps ) {
        if( prevProps.visible !== this.props.visible && this.props.visible ) {
            var task = 'editing';
            var block;

            if( this.props.block == 'new' ) {
                task = 'creating';
                block = {
                    run_date: this.props.run_date,
                    should_persist: true,
                };
            } else {
                block = {
                    ...this.props.block,
                    run_date: this.props.run_date,
                };
            }
            this.setState( {
                task: task,
                block: block,
                visible: true,
                fetching: false,
            } );
        }
        if( prevProps.visible !== this.props.visible && !this.props.visible ) {
            this.setState( {
                task: '',
                block: {},
                visible: false,
                deleteConfirm: false,
            } );
        }
    }
    submitHandler = ( values ) => {
        this.setState( { fetching: true } );

        this.props.onTaskComplete( this.state.task, values )
        .catch( ( err ) => {
            console.error( err );
            alert( 'Attempt Failed\nPlease make sure all values are valid and try to submit again.' );
            this.setState( { fetching: false } );
        } );

    }
    toggleDeleteConfirmation = ( ack ) => {
        return () => {
            this.setState( { deleteConfirm: ack } );
        };
    }
    deleteTag = () => {
        this.setState( { fetching: true } );
        this.props.onTaskComplete( 'deleting' )
        .catch( ( err ) => {
            console.error( err );
            alert( 'Attempt Failed\nPlease make sure all values are valid and try to submit again.' );
            this.setState( { fetching: false } );
        } );
    }



    render() {
        const { block, task } = this.state;
        const title = ( task == 'creating' ) ? 'New Block' : 'Edit Block';

        var initialValues = {};
        if( block.video ) {
            initialValues = {
                ...block.video,
                video_id: block.video.id,
                ...block,
                video: undefined,
            };
        } else {
            initialValues = {
                ...block,
            };
        }


        return (
            <DLModal title={ title } className={ style.blockModal }
            visible={ this.state.visible }
            closeHandler={ this.props.closeHandler }>
                <div>
                    <InnerForm onSubmit={ this.submitHandler } initialValues={ initialValues } />
                    { this.state.task == 'editing' && this.renderDeleteSection() }
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }

    renderDeleteSection = () => {
        if( this.state.deleteConfirm ) {
            return (
                <div className={style.deleteLink}>
                    <p>ARE YOU SURE YOU WANT TO DELETE THIS BLOCK?</p>
                    <p>
                        <span className={ style.confirmDelete }
                        onClick={ this.deleteTag }>
                            DELETE BLOCK
                        </span>
                        <span className={ style.cancelDelete }
                        onClick={ this.toggleDeleteConfirmation( false ) }>
                            CANCEL
                        </span>
                    </p>
                </div>
            );
        }
        return (
            <div className={style.deleteLink}>
                <span
                onClick={ this.toggleDeleteConfirmation( true ) }>
                    DELETE THIS BLOCK
                </span>
            </div>
        );
    }
}
BlockModal.defaultProps = {
    visible: false,
    onTaskComplete: () => { return Promise.resolve(); },
};

export default BlockModal;
